<template>
  <div class="broadcast-list-placeholder">
    <img
      class="placeholder-image"
      src="~@/assets/illustration-search.svg"
    >
    <div class="placeholder-text">
      <div class="text-top">
        In order to create custom market
      </div>
      <div class="text-main">
        Search
        <span class="text-highlight">CONRAD</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BroadcastListPlaceholder',
};
</script>

<style scoped lang="scss">
@import "~@/assets/scss/variables";

.broadcast-list-placeholder {
  position: relative;
  display: inline-block;
  margin-top: 117px;
  padding: 0 30px;
  text-align: center;
  font-family: Lato;
  color: white;
}

.placeholder-text {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding-top: 95px;

  .text-top {
    opacity: 0.5;
    color: white;
    font-size: 17px;
    line-height: 21px;
  }

  .text-main {
    font-size: 25px;
    line-height: 30px;
    margin-top: 12px;
  }

  .text-highlight {
    font-weight: $weight-black;
  }
}
</style>
